module.exports = __webpack_public_path__ + "img/icon_browser.37cd75e.png";